<template>
	<div>
		<div class="position_r">
			<img src='../assets/images/lb_04.png' class="toppic" alt="">
			<div class="topbox">
				<div class="kong">
					<div class="stitle " style="text-align: center;">
						协作让科学研究与工业研发变得
						<span>轻而易举</span>
					</div>
					<div class="all">
						<el-select v-model="value" id="inp" style="" placeholder="请选择">
							<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
						<div class="serbox">
							<i class="el-icon-search" style="font-size: 22px;color: #999999;"> </i>
							<input type="text" class="serput" placeholder="请输入搜索内容" @keydown.enter="goSearch" v-model="keyword">
						</div>
						<div class="serbut" @click="goSearch">
							检索
						</div>
					</div>
					<div style="color: #fff;margin-left:166px;margin-top: 15px;font-size: 18px;">
						  <el-carousel height="40px" direction="vertical" indicator-position="none" arrow='nerver'>
						    <el-carousel-item v-for="item in searchHotList" :key="item.id" >
						      <h3 class="medium" style="cursor: pointer;width: auto;display: inline-block;" @click="keyword = item.keywords">{{ item.keywords }}</h3>
						    </el-carousel-item>
						  </el-carousel>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapState,mapActions,mapMutations} from "vuex";
	export default{
		props:{
			searchType:{type:Number}
		},
		name: 'zongSou',
		data() {
			return{
				keyword:'',
				options: [
					{
						value: 0,
						label: '全部'
					},
					{
						value: 1,
						label: '项目需求池'
					}, 
					{
						value: 2,
						label: '资源工具池'
					}, 
					{
						value: 3,
						label: '解决方案池'
					}, 
					{
						value: 4,
						label: '产品服务池'
					}, 
					{
						value: 5,
						label: '牛人俱乐部'
					}],
				value:0,
				searchHotList:''
			}
		},
		created() {
			if(this.searchType){
				setTimeout(()=>{
					this.value = this.searchType
				},100)
			}
			this.getHotWords()
		},
		computed:{
			 ...mapState("globalSearch",["searchWord","optionValue"]),
		},
		mounted() {
			
			if (this.$route.query.search){
				this.keyword = this.$route.query.search
			} else {
				this.keyword = this.searchWord
			}
			this.value = this.optionValue
			// console.log('默认值：',this.optionValue);
			if(this.optionValue==''){
				this.value = this.options[0].value; // 设置 value 为第一个选项的 value 
			}
			
		},
		methods:{
			
			...mapMutations("globalSearch",['SET_OPTION','SET_WORD']),
			async getHotWords(){
				const hotList = await this.$api.getHotWords()
				this.searchHotList = hotList.data
				console.log(hotList.data,'getHotWords');
			},
			goSearch(){
				this.SET_OPTION(this.value)
				this.SET_WORD(this.keyword)
				console.log('搜索关键字：',this.keyword)
				switch (this.value) 
				{ 
				  case 0:this.$router.push(`/allsearchRefine?search=${this.searchWord}`); 
				  break; 
				  case 1:this.$router.push(`/allsearchRefine/xmxqC?search=${this.searchWord}`); 
				  break; 
				  case 2:this.$router.push(`/ResourceTools?search=${this.searchWord}`); 
				  break; 
				  case 3:this.$router.push(`/searchIndex/Solution?search=${this.searchWord}`); 
				  break; 
				  case 4:this.$router.push(`/proIndex/productService?search=${this.searchWord}`); 
				  break; 
				  case 5:this.$router.push(`/geniusClub/searchResult?search=${this.searchWord}`); 
				  break; 
				}
			},
		}
	}
</script>

<style>
</style>